import React, { useState, useEffect } from "react";
import "./Skills.css";

export default function Skills({ data }) {
  const [animated, setAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setAnimated(true), 500);
    return () => clearTimeout(timer);
  }, []);

  // Add proficiency levels to skills data
  const skillsWithLevels = data.map(skill => ({
    ...skill,
    level: Math.floor(Math.random() * 30) + 70 // Random level between 70-100%
  }));

  return (
    <section id="skills" className="skills section">
      <div className="container">
        <span className="section-label">03 — Skills</span>
        <h2 className="section-title">Skills &amp;<br />Strengths</h2>
        <div className="skills__grid">
          {skillsWithLevels.map((skill, i) => (
            <div className="skill-card" key={i} style={{ animationDelay: `${i * 0.08}s` }}>
              <div className="skill-card__icon">{skill.icon}</div>
              <h3 className="skill-card__title">{skill.title}</h3>
              <p className="skill-card__desc">{skill.desc}</p>

              <div className="skill-progress">
                <div className="skill-progress__bar">
                  <div
                    className={`skill-progress__fill ${animated ? "skill-progress__fill--animated" : ""}`}
                    style={{
                      width: animated ? `${skill.level}%` : "0%",
                      background: `linear-gradient(90deg, var(--purple-glow), var(--cyan))`
                    }}
                  />
                </div>
                <span className="skill-progress__percent">{skill.level}%</span>
              </div>

              <div className="skill-card__tags">
                {skill.tags.map((t) => (
                  <span key={t} className="skill-tag">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
